// Arrow.tsx
import './Arrow.scss'

import React, { FC } from 'react'

import { svgs } from './ArrowSvgs'

interface ArrowProps {
  direction?: 'left' | 'right'
  hasGrass?: boolean
  size?: 'small' | 'medium' | 'large'
}

export const Arrow: FC<ArrowProps> = ({
  direction = 'right',
  hasGrass = false,
  size = 'large',
}) => {
  return (
    <div className={`arrow-wrapper ${direction === 'left' ? 'arrow__flip' : ''}`}>
      {!hasGrass ? (
        <>{svgs.arrow_plain[size]}</>
      ) : (
        <div className={'arrow__hasgrass'}>{svgs.arrow_hasgrass[size]}</div>
      )}
    </div>
  )
}
